<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="message">
            <defs>
                <path v-if="hasSub" id="ghxfkd3lza" d="M17.72 4H6.28C5.023 4 4 5.021 4 6.276v13.048c0 .26.157.496.399.596.08.033.164.049.247.049.168 0 .334-.066.457-.19l3.08-3.072h9.537c1.257 0 2.28-1.021 2.28-2.276V6.276C20 5.021 18.977 4 17.72 4z"/>
                <path v-else id="7ypvimzx6a" d="M17.72 4H6.28C5.023 4 4 5.021 4 6.276v13.048c0 .26.157.496.399.596.08.033.164.049.247.049.168 0 .334-.066.457-.19l3.08-3.072h9.537c1.257 0 2.28-1.021 2.28-2.276V6.276C20 5.021 18.977 4 17.72 4zm.987 10.43c0 .544-.443.987-.988.987H7.915c-.172 0-.336.068-.457.189l-2.165 2.16V6.276c0-.544.443-.986.987-.986h11.44c.544 0 .987.442.987.986v8.155z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask :id="`${id}1ww5ijg4db`" fill="#fff">
                    <use v-if="hasSub" xlink:href="#ghxfkd3lza"/>
                    <use v-else xlink:href="#7ypvimzx6a"/>
                </mask>
                <g class="path" :fill="fill" :mask="`url(#${id}1ww5ijg4db)`">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-message',
    computed: {
        fill() {
            if(this.hasSub) return 'url(#linearGradient-1)'
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        id: {
            type: Number,
            default: 1
        },
        hasSub: {
            type: Boolean,
            default: false
        },
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>